/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Page_TitleInputs */

const en_home_page_title = /** @type {(inputs: Home_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in`)
};

const fr_home_page_title = /** @type {(inputs: Home_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connexion`)
};

const ms_sg2_home_page_title = /** @type {(inputs: Home_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log masuk`)
};

/**
* | output |
* | --- |
* | "Sign in" |
*
* @param {Home_Page_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const home_page_title = /** @type {((inputs?: Home_Page_TitleInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Page_TitleInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_page_title(inputs)
	if (locale === "fr") return fr_home_page_title(inputs)
	return ms_sg2_home_page_title(inputs)
});